import type { TranscriptsPlayer } from "@circle-react-uikit/TranscriptsPlayer";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";
import type { ComponentPropsWithoutRef } from "react";
import { Suspense } from "react";

const TranscriptsPlayerComponent = lazyWithRetry(() =>
  import(
    /* webpackChunkName: "TranscriptsPlayer" */ "@circle-react-uikit/TranscriptsPlayer"
  ).then(mod => ({ default: mod.TranscriptsPlayer })),
);

export const LazyTranscriptsPlayer = (
  props: ComponentPropsWithoutRef<typeof TranscriptsPlayer>,
) => (
  <Suspense fallback={<PageLoader />}>
    <TranscriptsPlayerComponent {...props} />
  </Suspense>
);
